// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Security } from './security';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class SecurityType extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  securityTypeId!: number;
  createdBy!: string;
  createdDate!: Date;
  description!: string;
  displayOrder!: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  securities!: Security[];
}

